export enum SubsectionsButtonsOptions {
    BROWSE = 'browse',
    SUPPLY = 'customerSupplied',
    NONE = 'none',
}
